<template>
  <div class="modal-wrap" ref="modal" v-show="show">
    <div class="modal-cover" @click="handleCoverClick"></div>

    <div
      class="modal"
      :class="{ auto_scale: shouldNotAutoScale ? false : true }"
    >
      <div class="modal-content">
        <slot name="modal-content" />
      </div>
      <div
        class="close"
        v-if="showClose"
        @click="handleCloseBtnClick('closeBtn')"
      ></div>
    </div>

    <span class="back" v-show="showBack" @click="handleBackClick" />
  </div>
</template>

<script>
/* eslint-disable max-len */
import pageScrollCtrl from '../../js/page-scroll-ctrl';

const Modal = {
  name: 'CustomRuleModal',
  props: {
    // 弹窗对应的关闭 flag
    name: {
      type: String
    },
    // 点击背景是否可以关闭
    coverCloseable: {
      type: Boolean,
      default: true
    },
    // 是否展示返回按钮
    showBack: {
      type: Boolean,
      default: false
    },
    // 是否展示关闭按钮
    showClose: {
      type: Boolean,
      default: false
    },
    // 关闭按钮处理函数
    closeBtnHandler: {
      type: Function
    },
    // 点击 cover 处理
    coverHandler: {
      type: Function
    },
    shouldNotAutoScale: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    /**
     * 关闭通用处理
     * */
    handleClose() {
      this.$emit('modalClose');
    },
    /**
     * 处理点击蒙层处理
     * */
    handleCoverClick() {
      if (!this.coverCloseable) {
        return false;
      }

      if (this.coverHandler) {
        this.coverHandler();
        return false;
      }
      this.$emit('modalClose', 'cover');
    },
    /**
     * 处理一下关闭按钮
     */
    handleCloseBtnClick() {
      if (this.closeBtnHandler) {
        this.closeBtnHandler();
        return false;
      }
      this.$emit('modalClose', 'closeBtn');
    },
    /**
     * 处理返回
     */
    handleBackClick() {
      this.$emit('modalBack', 'back');
    },
    /**
     * 弹窗定位
     */
    resizePosition() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop || 0;
      const { modal } = this.$refs;
      modal.style.top = `${scrollTop}px`;
    }
  },
  data() {
    return {
      show: true,
      scrollTop: -1
    };
  },
  beforeCreate() {
    pageScrollCtrl.lock('modal');
  },
  beforeDestroy() {
    pageScrollCtrl.unlock('modal');
  }
};

export default Modal;
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "../../css/common-mixin.scss";

.modal-content {
  height: 100%;
  overflow-y: scroll;
}

.modal-wrap {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow: hidden;
  z-index: 99;
  .modal-cover {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: transparent;
  }
  .back {
    opacity: 0;
    position: absolute;
    top: rpx(30px);
    left: rpx(40px);
    width: rpx(21px);
    height: rpx(38px);
    animation: fadeIn 0.1s 0.4s linear forwards;
  }
}

.modal {
  position: absolute;
  width: 100%;
  height: rpx(950);
  overflow-y: scroll;
  background-size: contain;
  bottom: 0;
  background: #fff;
  border-radius: rpx(50) rpx(50) 0 0;
  .close {
    position: absolute;
    border: 2px solid rgba(200,200,200,0.75);
    border-radius: rpx(25);
    top: rpx(40);
    right: rpx(30);
    width: rpx(80);
    height: rpx(50);
    background: url('assets/modal/reward-detai/know-btn-common.png') center no-repeat;
    background-size: rpx(100) rpx(70);
  }
}

</style>
